module.exports = __webpack_public_path__ + "img/PIGGY-alt.1cf5c647.svg";